export default [
  {
    path: "/pedidos",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "pedidos_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "pedidos", to: "pedidos_list" }],
          permission: "pedido:view",
          title: "Pedidos",
        },
      },
      {
        name: "pedidos_show",
        path: ":id",
        component: () => import("./pages/Show"),
        meta: {
          breadcrumbs: [{ label: "pedidos", to: "pedidos_list" }],
          permission: "pedido:view",
          title: "Pedidos - Visualização",
        },
      },
    ],
  },
];
